import React from 'react';
import { observer } from 'mobx-react-lite';
import { useInjection } from 'services/ioc/ioc.react';
import { TaggingStore } from 'stores/Tagging/TaggingStore';
import { ServiceTypes } from 'constants/ServiceTypes';
import { Button, Modal } from '@trackman/web-shared-components';
import { Content, ContentWrapper, Controls } from './InningChangeModalStyles';

interface IProps {
  onDismissCallback: () => void;
}

const InningChangeModal: React.FC<IProps> = observer(({ onDismissCallback }) => {
  const taggingStore = useInjection<TaggingStore>(ServiceTypes.TaggingStore);
  const { playStore } = taggingStore;

  const handleOnClick = (): void => {
    if (playStore.decraseInningRequest) {
      playStore.decreaseInning();
    }
    if (playStore.increaseInningRequest) {
      playStore.increaseInning();
    }
  };

  const renderInningChangeText = (): string => {
    if (playStore.increaseInningRequest) {
      return 'increase';
    }
    if (playStore.decraseInningRequest) {
      return 'decrease';
    }
    return 'change';
  };

  return (
    <Modal onClose={onDismissCallback} open title={`${renderInningChangeText()} inning?`}>
      <ContentWrapper>
        <Content>Are you sure that you want to {renderInningChangeText()} inning?</Content>
        <Controls>
          <Button width='49%' intent='primary' label='No' onClick={onDismissCallback} />
          <Button width='49%' intent='primary' label='Yes' onClick={handleOnClick} data-testid={'confirm-inning-change'} />
        </Controls>
      </ContentWrapper>
    </Modal>
  );
});

export default InningChangeModal;
